import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "cart" };
const _hoisted_2 = {
    key: 1,
    class: "data-item data-item--condensed"
};
const _hoisted_3 = { class: "data-item__header" };
const _hoisted_4 = { class: "data-item__nav" };
const _hoisted_5 = { class: "data-item__title" };
const _hoisted_6 = { class: "data-item__content" };
const _hoisted_7 = {
    key: 0,
    class: "cart__empty"
};
const _hoisted_8 = { class: "cart__footer" };
import { onMounted, onUnmounted, ref } from 'vue';
import { useRouter } from "vue-router";
import carts from '@astina/paloma-shop-common-ui/src/services/CartRepository';
import env from '../services/AppEnv';
import events from '@astina/paloma-common-ui/src/services/EventBus';
import Spinner from "@astina/paloma-common-ui/src/components/Spinner.vue";
import CurrentlyUnavailable from "../components/CurrentlyUnavailable.vue";
import Icon from "@astina/paloma-common-ui/src/components/Icon.vue";
import sidebarContext from '../services/AppSidebarContext';
import ShoppingCartItem from "./ShoppingCartItem.vue";
import { updateCartItems } from "../commands/UpdateCartItems";
import orderUtils from "@astina/paloma-shop-common-ui/src/services/OrderUtils";
import OrderTotal from "@astina/paloma-shop-common-ui/src/components/OrderTotal.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ShoppingCartSidebar',
    setup(__props) {
        const router = useRouter();
        const cart = ref(null);
        const unavailable = ref(false);
        const orderTotals = ref(null);
        onMounted(() => {
            loadActiveCart();
            events.$on('command.activate_cart.success', loadActiveCart);
            events.$on([
                'command.delete_cart.success',
                'command.delete_order_draft.success'
            ], onCartDelete);
            events.$on([
                'command.add_cart_items.success',
                'command.update_cart_items.success',
            ], onItemsChanged);
        });
        onUnmounted(() => {
            events.$off('command.activate_cart.success', loadActiveCart);
            events.$off([
                'command.delete_cart.success',
                'command.delete_order_draft.success'
            ], onCartDelete);
            events.$off([
                'command.add_cart_items.success',
                'command.update_cart_items.success',
            ], onItemsChanged);
        });
        function close() {
            sidebarContext.closeCartSidebar();
        }
        function toOrderDraft() {
            router.push({ name: 'orders_draft', params: { id: cart.value?.id } })
                .finally(close)
                .catch(() => {
            });
        }
        function onItemQuantityChange(item, quantity) {
            if (cart.value === null ||
                (item.quantity === quantity.quantity) && (item.portions === quantity.portions)) {
                return;
            }
            updateCartItems([{
                    itemId: item.id,
                    quantity: quantity.quantity,
                    portions: quantity.portions,
                }], cart.value.id)
                .then(updateCart);
        }
        function onItemParamsChange(item, params) {
            if (cart.value === null) {
                return;
            }
            updateCartItems([{
                    itemId: item.id,
                    quantity: item.quantity,
                    parameters: params,
                }], cart.value.id)
                .then(updateCart);
        }
        function onItemRemove(item) {
            onItemQuantityChange(item, { quantity: 0 });
        }
        function updateCart(cartParam) {
            if (!cart.value) {
                loadActiveCart();
                return;
            }
            // removed items
            const itemIds = cartParam.itemIds || [];
            const toRemove = [];
            const orderDraft = cart.value;
            orderDraft.items.forEach(item => {
                if (itemIds.indexOf(item.id) === -1) {
                    toRemove.push(item.id);
                }
            });
            toRemove.forEach(id => {
                const item = orderDraft.items.find(item => id === item.id);
                item && orderDraft.items.splice(orderDraft.items.indexOf(item), 1);
            });
            // updated items
            (cartParam.updatedItems || []).forEach(update => {
                updateItem(orderDraft, update);
            });
            // new items
            (cartParam.addedItems || []).forEach(added => {
                const item = orderDraft.items.find(item => added.id === item.id);
                if (!item) {
                    orderDraft.items.push(added);
                }
            });
            // totals TODO
            orderTotals.value.itemsTotal = cartParam.orderTotal;
            orderTotals.value.orderTotal = cartParam.orderTotal;
            orderTotals.value.netOrderTotal = cartParam.orderTotal;
        }
        function updateItem(orderDraft, update) {
            const item = orderDraft.items.find(item => update.id === item.id);
            if (item) {
                item.parameters = update.parameters;
                item.quantity = update.quantity;
                item.portions = update.portions;
                item.itemPricing = update.itemPricing;
                item.unitPricing = update.unitPricing;
            }
            else {
                orderDraft.items.push(update);
            }
        }
        function loadActiveCart() {
            cart.value = null;
            unavailable.value = false;
            env.orders.activeDraft && carts.getCart(env.orders.activeDraft)
                .then(data => {
                onLoad(data);
            })
                .catch(() => unavailable.value = true);
        }
        function onLoad(cartParam) {
            cart.value = cartParam;
            orderTotals.value = orderUtils.createOrderTotals(cartParam);
            events.$emit('cart-loaded', cartParam);
        }
        function onCartDelete(cartId) {
            if (cart.value && cartId === cart.value.id) {
                cart.value = null;
                close();
            }
        }
        function onItemsChanged(cartParam) {
            if (cart.value && cartParam.id === cart.value.id) {
                updateCart(cartParam);
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(Spinner, {
                    loading: !cart.value && !unavailable.value
                }, null, 8, ["loading"]),
                _cache[7] || (_cache[7] = _createTextVNode()),
                (!cart.value && unavailable.value)
                    ? (_openBlock(), _createBlock(CurrentlyUnavailable, { key: 0 }))
                    : _createCommentVNode("", true),
                _cache[8] || (_cache[8] = _createTextVNode()),
                (cart.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("a", {
                                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (close()), ["prevent"])),
                                    class: "data-item__nav-item",
                                    href: ""
                                }, [
                                    _createVNode(Icon, { name: "close" })
                                ])
                            ]),
                            _cache[2] || (_cache[2] = _createTextVNode()),
                            _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t('cart')), 1)
                        ]),
                        _cache[5] || (_cache[5] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_6, [
                            (cart.value.items.length === 0)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.$t('cart.empty')), 1))
                                : _createCommentVNode("", true),
                            _cache[3] || (_cache[3] = _createTextVNode()),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cart.value.items, (item) => {
                                return (_openBlock(), _createBlock(ShoppingCartItem, {
                                    item: item,
                                    "tax-included": cart.value.taxIncluded,
                                    "cart-id": cart.value.id,
                                    key: item.id,
                                    onItemQuantityChange: onItemQuantityChange,
                                    onItemParamsChange: onItemParamsChange,
                                    onItemRemove: onItemRemove
                                }, null, 8, ["item", "tax-included", "cart-id"]));
                            }), 128))
                        ]),
                        _cache[6] || (_cache[6] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_8, [
                            (orderTotals.value)
                                ? (_openBlock(), _createBlock(OrderTotal, {
                                    key: 0,
                                    currency: cart.value.currency,
                                    totals: orderTotals.value,
                                    "tax-included": cart.value.taxIncluded
                                }, null, 8, ["currency", "totals", "tax-included"]))
                                : _createCommentVNode("", true),
                            _cache[4] || (_cache[4] = _createTextVNode()),
                            _createElementVNode("a", {
                                onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (toOrderDraft()), ["prevent"])),
                                href: "",
                                class: "button"
                            }, [
                                _createVNode(Icon, { name: "cart" }),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('orders.show_draft')), 1)
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
